import { Pipe, PipeTransform } from '@angular/core';
import { MobilePhoneRaw, ParsePhoneString } from '@ui/pipes/display-phone/parse-phone-string';


@Pipe({
    name: 'displayPhone',
    standalone: true,
})
export class DisplayPhonePipe implements PipeTransform {
    public transform(value: string): string {
        if (value) {
            const mobilePhoneRaw: MobilePhoneRaw = new ParsePhoneString(value);
            return '+' + mobilePhoneRaw.phoneCode + mobilePhoneRaw.phoneNumber;
        }

        return '';
    }
}
